import { Button, Img, Heading, Text } from "./..";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ImagesCarousel from "components/ImagesCarousel";
import { API_DOMAIN } from "config";
import { formatPrice } from "utils/formatPrice";
import axios from "axios";
const statusMap = {
 // 0: { txt: "ממתין להצעה", clr: "black" },
    0: { txt: "ממתין להצעה", clr: "#CE0000"  },
  1: { txt: "ממתין לאישור", clr: "#CE0000" },
  2: { txt: "מאושר", clr: "#619D1C" },
  3: { txt: "הצעה שנדחתה", clr: "#666666" },
  4: { txt: "ארכיון", clr: "#666666" },
  5: { txt: "לא מעונין", clr: "#666666" }, // NEW
  6: { txt: "העסקה נסגרה ברכישה מידית", clr: "#666666" },
};
function ContactUserIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M20 21a8 8 0 0 0-16 0M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ContactPhoneIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.35 1.78.68 2.62a2 2 0 0 1-.45 2.11L8.1 9.64a16 16 0 0 0 6.26 6.26l1.19-1.19a2 2 0 0 1 2.11-.45c.84.33 1.72.56 2.62.68A2 2 0 0 1 22 16.92Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ContactPinIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path
        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        stroke="#7CB342"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ContactDetailsCard({
  contactName,
  contactPhone,
  contactLocation,
  onClose = null,
  compact = false,
}) {
  const initial = (contactName || "S").trim().charAt(0) || "S";

  return (
    <div
      dir="rtl"
      style={{backgroundColor: 'white'}}
      className={`relative rounded-[18px] border border-gray-200 bg-white shadow-[0_10px_30px_rgba(0,0,0,0.14)] ${
        compact ? "w-[320px] p-4" : "w-[360px] max-w-[92vw] p-5"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      {onClose && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose();
          }}
          className="absolute left-3 top-3 text-gray-400 hover:text-gray-600 text-[28px] leading-none"
          aria-label="סגירה"
        >
          ×
        </button>
      )}

      <div style={{backgroundColor: 'white', fontWeight: '500'}} className={`text-center font-heebo text-black text-[18px]`}>
        פרטי התקשרות
      </div>

      <div className="relative mt-4">
     

        <div className="space-y-2 pl-14">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactUserIcon />
              <span className="font-heebo text-black text-[18px] font-medium">שם איש קשר:</span>
            </div>
            <span className="font-heebo text-[16px] text-black text-left break-words">
              {contactName || "-"}
            </span>
          </div>

          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-1.5 shrink-0">
              <ContactPhoneIcon />
<span className="font-heebo text-black text-[18px] font-medium">פלאפון:</span>            </div>
            <span className="font-heebo text-[16px] text-black text-left" dir="ltr">
              {contactPhone || "-"}
            </span>
          </div>

  
        </div>
      </div>
    </div>
  );
}
export default function CarCard({
  id,
  user_id,
  license_plate,
  year,
  manufacturer,
  model,
  sub_model,
  accident_type,
  damage_estimate,
  sale_type,
  asking_price,
  status,
  creation_date,
  updated_date,
  transmission,
  hand,
  car_type,
  kilometer,
  gearbox,
  original_ownership,
  annual_registration_fee,
  finish_level,
  engine_capacity,
  engine_type,
  chassis_number,
  accessories,
  images = [],
  sale_type_id,
  offer_status = 0,
  offered_price,
  action,
  onOfferClick = null, // New prop to handle offer click
  currentUser,
  onUpdate,
  // ✅ פרטי קשר יכולים להגיע ישירות כ-props (ולא רק בתוך ...props)
  contact_name,
  main_contact_name,
  contact_person_name,
  owner_name,
  seller_name,
  full_name,
  supplier_name,
  contact_phone,
  phone,
  seller_phone,
  user_phone,
  phone_number,
  meeting_location,
  offer_location,
  meeting_place,
  address,
  contact_location,
  full_address,
  location: locationProp,
  ...props
}) {
  const navigate = useNavigate();
const openContactDetails = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (!hasContactDetails) return;

  // במובייל פותחים popup
  if (!canHover) {
    setShowContactModal(true);
  }
};

const closeContactDetails = () => {
  setShowContactModal(false);
};

const onContactMouseEnter = (e) => {
  e.preventDefault();
  e.stopPropagation();

  if (canHover && hasContactDetails) {
    setShowContactTooltip(true);
  }
};

const onContactMouseLeave = () => {
  if (canHover) {
    setShowContactTooltip(false);
  }
};
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const yr = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${yr}`;
  };
const [btnBusy, setBtnBusy] = useState(false);
const location = useLocation();

  const [tooltipVisible, setTooltipVisible] = useState(true);
  const hideTimer = useRef(null);
const isArchived = Number(props.is_archive ?? props.isArchive ?? 0) === 1;
const isImmediatePurchaseClosed = Number(props.immediate_purchase_closed ?? props.immediatePurchaseClosed ?? 0) === 1;

const displayStatus = isArchived
  ? 5
  : (offer_status === 0 && props.approved_other === 1 ? (isImmediatePurchaseClosed ? 6 : 4) : offer_status);
  const offerText = props.offer_range ?? offered_price ?? null;

  const { txt, clr } = statusMap[displayStatus] || statusMap[0];
  const isWaitingForOffer = displayStatus === 0;

  const [localStatus, setLocalStatus] = useState(displayStatus);
const [showContactTooltip, setShowContactTooltip] = useState(false);
const [showContactModal, setShowContactModal] = useState(false);
const [canHover, setCanHover] = useState(false);

// סנכרון סטטוס מקומי עם props
useEffect(() => {
  setLocalStatus(displayStatus);
}, [displayStatus]);

// זיהוי דסקטופ (hover + mouse)
useEffect(() => {
  if (typeof window === "undefined" || !window.matchMedia) return;

  const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
  const updateHoverCapability = () => setCanHover(mq.matches);
  updateHoverCapability();

  if (mq.addEventListener) {
    mq.addEventListener("change", updateHoverCapability);
    return () => mq.removeEventListener("change", updateHoverCapability);
  } else {
    mq.addListener(updateHoverCapability);
    return () => mq.removeListener(updateHoverCapability);
  }
}, []);

// סגירת popup ב-Escape
useEffect(() => {
  if (!showContactModal) return;

  const onKeyDown = (e) => {
    if (e.key === "Escape") setShowContactModal(false);
  };

  window.addEventListener("keydown", onKeyDown);
  return () => window.removeEventListener("keydown", onKeyDown);
}, [showContactModal]);

// נתוני איש קשר (fallbacks)
const contactName =
  contact_name ??
  main_contact_name ??
  contact_person_name ??
  owner_name ??
  seller_name ??
  full_name ??
  supplier_name ??
  props.contact_name ??
  props.main_contact_name ??
  props.contact_person_name ??
  props.owner_name ??
  props.seller_name ??
  props.full_name ??
  props.supplier_name ??
  "";

const contactPhone =
  contact_phone ??
  phone ??
  seller_phone ??
  user_phone ??
  phone_number ??
  props.contact_phone ??
  props.phone ??
  props.seller_phone ??
  props.user_phone ??
  props.phone_number ??
  "";

const contactLocation =
  meeting_location ??
  offer_location ??
  meeting_place ??
  address ??
  contact_location ??
  full_address ??
  locationProp ??
  props.meeting_location ??
  props.offer_location ??
  props.meeting_place ??
  props.address ??
  props.location ??
  props.contact_location ??
  props.full_address ??
  "";

const hasContactDetails = Boolean(contactName || contactPhone || contactLocation);

// סטטוס אפקטיבי ל-UI
const effectiveStatus = localStatus;

const isApproved = effectiveStatus === 2;
const actionText = action ?? (currentUser?.user_type === 2 ? "לצפיה במודעה" : "תן הצעה");

const markNotInterested = async () => {
  if (btnBusy) return;
  setBtnBusy(true);

  try {
    await axios.post(`${API_DOMAIN}/car/markNotInterested`, {
      car_id: id,
      user_id: currentUser.id,
    });

    setLocalStatus(5);
    onUpdate?.(id, 5);
  } catch (err) {
    console.error(err);
  } finally {
    setBtnBusy(false);
  }
};

const removeNotInterested = async () => {
  if (btnBusy) return;
  setBtnBusy(true);

  try {
    await axios.post(`${API_DOMAIN}/car/removeNotInterested`, {
      car_id: id,
      user_id: currentUser.id,
    });

    setLocalStatus(0);
    onUpdate?.(id, 0);
  } catch (err) {
    console.error(err);
  } finally {
    setBtnBusy(false);
  }
};



  const handleMouseEnter = () => {
    clearTimeout(hideTimer.current);
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    hideTimer.current = setTimeout(() => setTooltipVisible(false), 3000);
  };

  useEffect(() => {
    return () => clearTimeout(hideTimer.current);
  }, []);

  const handleClick = () => {
    if (onOfferClick) {
      onOfferClick(props); // props כבר מכיל offer_id
    } else {
      const targetPath = currentUser?.user_type === 2
        ? `/provider-cars/${id}`
        : `/dealer-cars/${id}`;
      navigate(targetPath);
    }
  };

  const formatOfferText = (text) => {
    if (text === null || text === undefined || text === "") return "";
    const s = String(text);

    if (s.includes("-")) {
      return s
        .split("-")
        .map((v) => formatPrice(v))
        .join("-");
    }
    return formatPrice(s);
  };

  return (
    <>
    <div
      {...props}
      className={`vehicle-card car-single-card relative flex flex-col w-full rounded-[16px] ${
        props.className || ""
      }`}
      data-testid="vehicle-card"
      style={{
        // חשוב: כדי שבתוך grid/list הכרטיסים יהיו שווי גובה
        height: "100%",
      }}
    >
      {/* ====== TOP: IMAGE AREA (FIXED HEIGHT) ====== */}
      {/* ====== TOP: IMAGE AREA (FIXED HEIGHT) ====== */}<div className="relative overflow-hidden rounded-t-[16px]">


        <Button
          shape="round"
          className="status-badge ml-[15px] mt-[17px] rounded-[14px] font-assistant font-medium capitalize text-white sm:px-5"
          data-testid="status-badge"
          style={{
            zIndex: 999,
            backgroundColor: clr,
            color: "white",
            paddingTop: "14px",
            paddingBottom: "14px",
            paddingRight: "20px",
            paddingLeft: "20px",
            position: "absolute",
          }}
        >
          {txt}
        </Button>

        {isWaitingForOffer ? (
          <div
            className="absolute w-full bottom-0 flex justify-center py-1"
            style={{ backgroundColor: clr, opacity: 0.8, zIndex: 999 }}
          >
            <Heading
              size="headingxl"
              className="!font-heebo text-[14px] font-bold !text-secondary-primary_white ml-2"
            >
              מחיר מומלץ: ₪{formatPrice(asking_price)}
            </Heading>
          </div>
        ) : (
          offerText && (
            <div
              className="absolute w-full bottom-0 flex justify-center py-1"
              style={{ backgroundColor: clr, opacity: 0.8, zIndex: 999 }}
            >
              <Heading
                size="headingxl"
                className="!font-heebo text-[14px] font-bold !text-secondary-primary_white ml-2"
              >
                {String(offerText).includes("-")
                  ? "טווח הצעות: " + formatOfferText(offerText)
                  : "מחיר ההצעה: ₪" + formatOfferText(offerText)}
              </Heading>
            </div>
          )
        )}

        <ImagesCarousel images={images || []} />
      </div>

      {/* ====== BODY (FLEX-1) to force uniform height ====== */}
      <div
        onClick={handleClick}
         dir="ltr"
        className="relative cursor-pointer flex-1 flex flex-col self-stretch rounded-bl-[16px] rounded-br-[16px] border border-solid border-gray-200 bg-secondary-primary_white p-5"
      >
        {/* ====== CONTENT STACK ====== */}
        <div className="flex flex-col w-full">
          {/* 🔒 TITLE BLOCK: fixed vertical start for all cards */}
          <div className="flex flex-col items-center gap-2 min-h-[72px]">
            <Heading
              as="h6"
              className="!font-heebo text-[18px] font-bold !text-black-900 text-center leading-[1.15] line-clamp-2"
              style={{
                // אם אין line-clamp בפרויקט שלך, זה עדיין יעבוד טוב בגלל min-h
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {model}
            </Heading>

            <div className="flex items-center justify-center gap-2.5">
              <Text as="p" className="text-[14px] font-normal">
                {year}
              </Text>
              <div className="h-[6px] w-[6px] rounded-[3px] bg-red-a700_03" />
              <Text
                as="p"
                className="text-[14px] font-normal line-clamp-1"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {manufacturer}
              </Text>
            </div>
          </div>

          {/* 🔒 SPECS BLOCK: same Y start always */}
          <div className="mt-4 w-full min-h-[56px]">
            <div className="flex self-stretch">
              <div className="flex w-full flex-col items-center gap-1.5 px-1">
                <Img src="images/img_icon_black_900_01.svg" alt="מנוע" className="h-[18px]" />
                <Text
                  as="p"
                  className="text-[14px] font-normal text-center line-clamp-1"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {engine_type}
                </Text>
              </div>

              <div className="flex w-full flex-col items-center gap-1.5 px-9 sm:px-5">
                <Img
                  src="images/img_artboard_2_copy_3_black_900_03_3.svg"
                  alt="יד"
                  className="h-[18px]"
                />
                <Text as="p" className="text-[14px] font-normal">
                  {hand}
                </Text>
              </div>

              <div className="flex w-full flex-col items-center gap-2 px-6 sm:px-5">
                <Img src="images/img_icon_black_900.svg" alt="גיר" className="h-[18px]" />
                <Text as="p" className="text-[14px] font-normal">
                  {gearbox}
                </Text>
              </div>
            </div>
          </div>

          {/* קו מפריד עליון */}
          <hr className="my-4 border-gray-200" />

          {/* 🔒 ACTION ROW: same Y start always */}
          <div className="flex items-center justify-between gap-4 min-h-[44px] relative">
            <div className="flex items-center justify-right gap-3">
              <img className="h-[14px]" src="/images/img_settings_black_900.svg" alt="" />
              <h6 className="text-black-900_03 font-assistant text-[16px] font-semibold lg:text-[13px]">
                {actionText}
              </h6>
            </div>

<div className="flex items-center gap-5" dir="rtl">
  {isApproved ? (
    <div
      className="relative"
      onMouseEnter={onContactMouseEnter}
      onMouseLeave={onContactMouseLeave}
      onClick={(e) => e.stopPropagation()}
    >
      <span
        type="button"
        onClick={openContactDetails}
        className={`min-w-[140px] r font-assistant font-medium flex items-center justify-center gap-2 ${
          hasContactDetails ? "cursor-pointer" : "opacity-60 cursor-not-allowed"
        }`}
        aria-label="פרטי התקשרות"
      >
                      <ContactUserIcon />

        <span className="text-black-900 text-[15px]">פרטי התקשרות</span>
      </span>

      {/* Tooltip בדסקטופ */}
    {canHover && showContactTooltip && hasContactDetails && (
     <div
          className="absolute inset-0 z-[2000] flex items-center justify-center pointer-events-none"
    >
      <div
        className="pointer-events-auto"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <ContactDetailsCard
          compact
          contactName={contactName}
          contactPhone={contactPhone}
          contactLocation={contactLocation}
        />
      </div>
    </div>
      )}
    </div>
  ) : (
    <Button
      shape="round"
      rightIcon={
        <Img
          src={
            sale_type_id === 1
              ? "/images/total.svg"
              : sale_type_id === 2
              ? "/images/img_television_red_a700_03_2.svg"
              : ""
          }
        />
      }
      className="min-w-[116px] gap-2 rounded-[14px] px-[18px] font-assistant font-medium capitalize !text-black-900"
    >
      {sale_type_id === 1 ? "פירוק" : sale_type_id === 2 ? "שיקום" : ""}
    </Button>
  )}
</div>
          </div>

          {/* קו מפריד תחתון */}
          <hr className="mt-4 border-gray-200" />
        </div>

        {/* ====== FOOTER pinned to bottom for uniformity ====== */}
        <div className="mt-auto flex flex-row-reverse items-center justify-between pt-3 w-full">
          <h6 className="text-black-900_03 font-assistant text-[14px]" style={{ color: "#808080" }}>
            תאריך פרסום: {formatDate(creation_date)}
          </h6>

          {currentUser?.user_type === 3 ? (
            localStatus === 0 ? (
              <span
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  markNotInterested();
                }}
                className={`whitespace-nowrap bg-black text-white text-xs rounded py-2 px-3 shadow-lg cursor-pointer ${
                  btnBusy ? "opacity-50 pointer-events-none" : ""
                }`}
              >
                העבר לארכיון
              </span>
            ) : localStatus === 5 ? (
              <span
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  removeNotInterested();
                }}
                className={`whitespace-nowrap bg-black text-white text-xs rounded py-2 px-3 shadow-lg cursor-pointer ${
                  btnBusy ? "opacity-50 pointer-events-none" : ""
                }`}
              >
                הסר מארכיון
              </span>
            ) : (
              <div style={{ width: 14 }} />
            )
          ) : (
            <div style={{ width: 14 }} />
          )}
        </div>
      </div>
    </div>

    {/* ✅ Popup במובייל */}
{showContactModal && !canHover && (
  <div
    className="fixed inset-0 z-[99999] flex items-center justify-center p-4"
    style={{
      backgroundColor: "rgba(0,0,0,0.82)", // ✅ יותר מושחר (תעלי ל-0.88 אם צריך)
      backdropFilter: "blur(2px)",         // אופציונלי, כמו בתמונה
    }}
    onClick={closeContactDetails}
  >
    <div
      className="relative"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ContactDetailsCard
        contactName={contactName}
        contactPhone={contactPhone}
        contactLocation={contactLocation}
        onClose={closeContactDetails}
      />
    </div>
  </div>
)}
    </>
  );
}
